import React, { Component } from "react";
import "rc-checkbox/assets/index.css";
import { connect } from "react-redux";
import "./EnterpriseActions.css";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import filter from "lodash/filter";
import uniqBy from "lodash/uniqBy";
import { table_column_names } from "../../utils/constants";

import {
  ListGroup,
  ListGroupItem,
  Progress,
  Breadcrumb,
  PopoverBody,
  PopoverHeader,
  Popover,
  Col,
  BreadcrumbItem,
  Button,
} from "reactstrap";
import CollapseControl from "./CollapseControl";
import If from "../../components/Shared/If";
import PlaceholderObjectivesActions from "./PlaceholderObjectivesActions";
import PieChart from "./ActionsPieChart.jsx";
import Activity from "./RecentEOActivity.jsx";
import AvgCompletion from "./AvgTaskCompletion.jsx";
import ActionCount from "./TotalActionCount.jsx";
import moment from "moment";
import { objectEncode } from "../../utils/updateObject";
import {
  sortActionsByDate,
  actionsByStatus,
  isUserRemoved,
  whiteLabelStyling,
} from "../../utils/constants";

import get from "lodash/get";
import size from "lodash/size";
import orderBy from "lodash/orderBy";
import { create } from "lodash";
import ActionsTable from "../weekly-wins/ActionsTable";
const noRecordAvailable = "No records available.";

class EnterpriseActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionCount: 0,
      isRunStats: false,
      isPopupOpen: null,
      tasks: [],
      status: "A",
      isEOArchived: false,
    };

    //  console.log(this.props)
  }

  componentDidMount = () => {
    let that = this;
    let orgId = this.props.user.profile.organizationId._id;
    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      that.props.orgChangeSuccess(payload);
    });

    this.fetchLatestData();

    this.props.updateNavBar({
      backButtonData: {
        show: true,
        currentPageType: "OBJECTIVE_DETAILS",
      },
    });
  };

  componentWillUnmount = () => {
    this.props.resetEnterpriseActions();

    this.props.updateNavBar({
      backButtonData: {
        show: false,
        currentPageType: "",
      },
    });
  };

  unLinkActionFromObjective = (actionId) => {
    const {
      objectiveActions: { enterpriseObjective },
    } = this.props;
    let payload = {
      objectiveId: get(
        this.props.objectiveActions,
        "enterpriseObjective[0]._id",
        ""
      ),
      actionId: actionId,
    };
    axios
      .post(url.unlinkEnterpriseObjectiveAction, objectEncode(payload))
      .then(() => {
        this.fetchLatestData();
      });
  };

  fetchLatestData = () => {
    let objectiveId = this.props.match.params.id;
    axios
      .get(`${url.getEnterpriseObjectiveActions}/${objectiveId}`)
      .then(({ data }) => {
        // console.log('Ent Obj---', data.data)
        let { linkedActions, enterpriseObjective } = data.data;
        this.setState({
          actionCount: linkedActions.length,
          tasks: [...linkedActions],
        });
        this.props.onFetchObjectiveActions(data.data);

        this.setState({
          isEOArchived:
            enterpriseObjective[0] && enterpriseObjective[0].isDeleted,
        });
      });
  };
  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  };

  viewAction = (item) => {
    this.props.history.push(`/home/planning/${item._id}`);
  };

  assignedUserCheck = (task) => {
    let assignedUser =
      task.assignedTo && task.assignedTo.firstName ? task.assignedTo : false;
    let currentUser = this.props.user.profile;
    if (task && assignedUser) {
      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + " " + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : "";

      let taskOwner =
        task.ownerFullName && task.isAnonymous != true
          ? task.ownerFullName
          : "Anonymous";

      if (task.assignedTo._id.toString() == currentUser._id.toString()) {
        taskOwner = task.ownerFullName;
      }

      assignedUser = isUserRemoved(task.assignedTo)
        ? "Inactive User"
        : assignedUser;
      taskOwner = isUserRemoved(taskOwner) ? "Inactive User" : taskOwner;

      return (
        <div className="allTasksAssignedUser">
          Assigned to {assignedUserFullName} by {taskOwner}
          {/* <span className="sendReminder" onClick={this}>Remind?</span> */}
        </div>
      );
    }
  };

  createdByTask = (task_copy) => {
    let currentUser = this.props.user.profile;
    let res;
    let isUserRemovedTest = isUserRemoved(task_copy.userId);
    if (isUserRemovedTest) {
      res = " Inactive User";
    } else if (task_copy.isAnonymous) {
      if (task_copy.userId.toString() != currentUser._id.toString()) {
        if (
          task_copy.assignedTo &&
          task_copy.assignedTo._id.toString() == currentUser._id.toString()
        ) {
          res = ` ${task_copy.userId.firstName} ${task_copy.userId.lastName}`;
        } else {
          res = " Anonymous";
        }
      } else {
        res = " You";
      }
    } else {
      if (task_copy.userId.toString() == currentUser._id.toString()) {
        res = " You";
      } else {
        res = ` ${task_copy.userId.firstName} ${task_copy.userId.lastName}`;
      }
    }
    return res;
  };

  checkProgressBarValue = (task) => {
    let res;
    if (
      task.percentComplete &&
      task.percentComplete.length > 0 &&
      task.percentComplete[0].value
    ) {
      res = task.percentComplete[0].value;
    } else if (
      task.incompleteDate &&
      new Date(task.incompleteDate).valueOf() != NaN
    ) {
      res = 0;
    } else if (
      task.completedDate &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      res = 100;
    } else if (
      task.incompleteDate &&
      task.completedDate &&
      new Date(task.incompleteDate).valueOf() != NaN &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      if (task.completedDate > task.incompleteDate) {
        res = 100;
      } else {
        res = 0;
      }
    } else {
      res = 0;
    }
    return res;
  };

  renderEAAssociatedActions = (tasks) => {
    const { orgAdmin } = this.props.user.profile;
    let list = sortActionsByDate(tasks);

    if (list && list.length > 0) {
      return list.map((item, index) => (
        <ListGroupItem
          key={item._id + index}
          className={
            item.isDeleted != true &&
            !item.completedDate &&
            item.dueDate &&
            item.dueDate != null &&
            item.dueDate != undefined
              ? moment(item.dueDate).format("YYYY-MM-DD") <
                moment().format("YYYY-MM-DD")
                ? "weekly-wins-todos dueDatePast"
                : "weekly-wins-todos"
              : "weekly-wins-todos"
          }
          style={whiteLabelStyling(
            ["borderColor"],
            this.props.user.profile.organizationId
          )}
        >
          <div className="objectives">
            {item.title} {item.completedDate ? "(Completed)" : ""}
            {item.isDeleted != true &&
            !item.completedDate &&
            item.dueDate &&
            item.dueDate != null &&
            item.dueDate != undefined ? (
              moment(item.dueDate).format("YYYY-MM-DD") <
              moment().format("YYYY-MM-DD") ? (
                <span className="allTasksCalendarContainer">
                  due on <i className="flaticon-calendar ml5"></i>{" "}
                  <span className="allTasksDueDate">
                    {moment(item.dueDate).format("MMM D, YYYY")}{" "}
                  </span>
                  <span className="dueDatePastTxt">(PAST DUE)</span>
                </span>
              ) : (
                <span className="allTasksCalendarContainer">
                  due on <i className="flaticon-calendar ml5"></i>{" "}
                  <span className="allTasksDueDate">
                    {moment(item.dueDate).format("MMM D, YYYY")}{" "}
                  </span>
                </span>
              )
            ) : !item.completedDate && !item.deletedDate && !item.dueDate ? (
              <span className="task_ongoing_txt">On-going</span>
            ) : null}
          </div>

          <span
            className="viewLinkedActionEO"
            onClick={() => this.viewAction(item)}
          >
            <span className="viewLinkedActionEOTxt"> View Action </span>
          </span>

          <div className="">
            <span>{`by ${this.createdByTask(item)} on ${moment(
              item.createdOn
            ).format("MMM D, YYYY")}`}</span>

            {item.lastUpdate ? (
              <span>{` * Updated on ${moment(item.lastUpdate).format(
                "MMM D, YYYY"
              )}`}</span>
            ) : null}
          </div>

          {this.assignedUserCheck(item)}

          {item.completedDate ? (
            <div>
              <span className="">
                {" "}
                Completed on
                {/* <i className="flaticon-calendar ml5"></i>  */}
                <span className="">
                  {" "}
                  {moment(item.completedDate).format("MMM D, YYYY")}{" "}
                </span>
              </span>
            </div>
          ) : null}

          {item.completedDate && item.dueDate ? (
            <span className="">
              {" "}
              (previous) Due date of
              {/* <i className="flaticon-calendar ml5"></i>  */}
              <span className="">
                {" "}
                {moment(item.dueDate).format("MMM D, YYYY")}{" "}
              </span>
            </span>
          ) : null}

          {(!item.completedDate || item.completedDate == null) &&
          item.deletedDate ? (
            <span className="">
              {" "}
              Archived on
              {/* <i className="flaticon-calendar ml5"></i>  */}
              <span className="">
                {" "}
                {moment(item.deletedDate).format("MMM D, YYYY")}{" "}
              </span>
            </span>
          ) : null}

          <div className="allTaskProgressContainer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="30"
              fill="currentColor"
              className="bi bi-card-checklist allTaskProgressIcon"
              viewBox="0 0 16 16"
            >
              <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
              <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z" />
            </svg>
            {this.checkProgressBarValue(item) == 0 ? (
              <span className="zeroPercentProgress">0%</span>
            ) : null}
            <Progress
              className={
                this.checkProgressBarValue(item) == 100
                  ? "allTaskProgress progressCompleted"
                  : "allTaskProgress"
              }
              striped={this.checkProgressBarValue(item) == 100 ? false : true}
              // value="25"
              // animated
              // multi
              color="success"
              value={this.checkProgressBarValue(item)}
            >
              {this.checkProgressBarValue(item)}%
            </Progress>
          </div>

          {/* <CollapseControl description={item.description} />    */}

          {/* userId */}
          {orgAdmin ||
          this.props.user.profile._id.toString() == item.userId.toString() ? (
            <div className="pull-right link-unlink unlinkActionEA">
              <i className="unlink"></i>
              <span onClick={() => this.unLinkActionFromObjective(item._id)}>
                Unlink
              </span>
            </div>
          ) : null}
        </ListGroupItem>
      ));
    }
    return (
      <div>
        <div>
          <div>{noRecordAvailable}</div>
        </div>
      </div>
    );
  };

  togglePopup = (val) => {
    let { isPopupOpen } = this.state;
    if (val == isPopupOpen) {
      this.setState({ isPopupOpen: null });
    } else {
      this.setState({ isPopupOpen: val });
    }
  };

  showActionByStatus = (allTasks, status) => {
    if (status == "A") {
      let list = sortActionsByDate(allTasks);
      this.setState({ tasks: list, status });
    } else {
      let tasks = [...allTasks];
      let res = actionsByStatus(tasks, status);
      this.setState({ tasks: res, status });
    }
  };

  handleUnDeleteTodo = (todo) => {
    axios.put(`${url.unarchiveObjective}/${todo._id}`).then(() => {
      this.setState({
        isEOArchived: false,
      });
    });

  };

  render() {
    let { actionCount, tasks, status, isEOArchived } = this.state;
    const {
      objectiveActions: { enterpriseObjective, linkedActions },
    } = this.props;

    const orgAdmin = this.props.user.profile.orgAdmin
    console.log("enterpriseObjective:  ", enterpriseObjective);
    return (
      <div>
        <div className="enterprise-actions enterpriseObjectiveActions">
          <div
            className="title-description"
            style={whiteLabelStyling(
              ["backgroundColor", "borderColor"],
              this.props.user.profile.organizationId
            )}
          >
            <div className="single_objectives_view_title">
              <span className="short-text">
                {get(
                  this.props.objectiveActions,
                  "enterpriseObjective[0].title",
                  ""
                )}
                <span className="">
                  {isEOArchived ? (
                    <span className="text-danger"> (Archived) </span>
                  ) : (
                    ""
                  )}
                </span>
                {isEOArchived && orgAdmin ? (
                  <span
                    style={{
                      fontSize: "15px",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => {
                      if(enterpriseObjective && enterpriseObjective[0]){
                        this.handleUnDeleteTodo(enterpriseObjective[0]);
                      } 
                     
                    }}
                  >
                    {" "}
                    Restore
                  </span>
                ) : (
                  ""
                )}
              </span>
            </div>
            <div className="single_objectives_view_date">
              {enterpriseObjective && enterpriseObjective[0]
                ? `created on ${moment(enterpriseObjective[0].createdOn).format(
                    "MMM D, YYYY"
                  )}`
                : null}
            </div>
            <div className="single_objectives_view_description">
              <CollapseControl
                description={get(
                  this.props.objectiveActions,
                  "enterpriseObjective[0].description",
                  ""
                )}
              />
            </div>
          </div>

          {linkedActions && linkedActions.length > 0 ? (
            <div className="enterpriseStatsContainer">
              <div className="allStatsRow">
              <Col
                lg={2}
                md={6}
                sm={6}
                className="enterpriseActionCount col-sm-6 col-md-2"
              >
                <span className="singleStatContainer">
                  <span className="entObjHelpIcon">
                    <span
                      className="ml10"
                      id="uniqueUsers"
                      onClick={() => this.togglePopup(1)}
                    >
                      <Tooltip />
                    </span>
                    <Popover
                      placement="left"
                      isOpen={this.state.isPopupOpen == 1 ? true : false}
                      target="uniqueUsers"
                      toggle={() => this.togglePopup(1)}
                    >
                      <PopoverHeader className="popover-header-tooltip">
                        Unique Users
                      </PopoverHeader>
                      <PopoverBody className="popover-body-tooltip">
                        Total number of actions that have been linked with the
                        objective on this page.
                      </PopoverBody>
                    </Popover>
                  </span>

                  <span className="enterpriseObjTitle">
                    Total <br />
                    Actions
                  </span>
                  <span className="enterpriseObjSubtitle">
                    towards this objective
                  </span>
                  <ActionCount
                    actionCount={actionCount}
                    eo_id={this.props.match.params.id}
                  />
                </span>
              </Col>

              <Col
                lg={4}
                md={6}
                sm={6}
                className="enterprisePieChart col-sm-6 col-md-4"
              >
                {/* <div className='enterprisePieChart col-sm-6 col-md-4'> */}

                <span className="singleStatContainer">
                  <span className="entObjHelpIcon">
                    <span
                      className="ml10"
                      id="actionEngagement"
                      onClick={() => this.togglePopup(2)}
                    >
                      <Tooltip />
                    </span>
                    <Popover
                      placement="left"
                      isOpen={this.state.isPopupOpen == 2 ? true : false}
                      target="actionEngagement"
                      toggle={() => this.togglePopup(2)}
                    >
                      <PopoverHeader className="popover-header-tooltip">
                        Action Status
                      </PopoverHeader>
                      <PopoverBody className="popover-body-tooltip">
                        Snapshot of progress on actions that are linked with the
                        objective on this page, indicated as: not started, in
                        progress, or completed.
                      </PopoverBody>
                    </Popover>
                  </span>

                  <span className="enterpriseObjTitle">Action Status</span>
                  <span className="enterpriseObjSubtitle">
                    for this Objective
                  </span>
                  <span className="individualEOpage">
                    <PieChart
                      actionCount={actionCount}
                      eo_id={this.props.match.params.id}
                    />
                  </span>
                </span>
              </Col>

              <Col
                lg={2}
                md={6}
                sm={6}
                className="enterpriseActionCount col-sm-6 col-md-2"
              >
                <span className="singleStatContainer">
                  <span className="entObjHelpIcon">
                    <span
                      className="ml10"
                      id="avgCompletion"
                      onClick={() => this.togglePopup(6)}
                    >
                      <Tooltip />
                    </span>
                    <Popover
                      placement="left"
                      isOpen={this.state.isPopupOpen == 6 ? true : false}
                      target="avgCompletion"
                      toggle={() => this.togglePopup(6)}
                    >
                      <PopoverHeader className="popover-header-tooltip">
                        Average Completion
                      </PopoverHeader>
                      <PopoverBody className="popover-body-tooltip">
                        Average progress of all actions that are linked with the
                        objective on this page.
                      </PopoverBody>
                    </Popover>
                  </span>
                  <span className="enterpriseObjTitle">Average Completion</span>
                  <span className="enterpriseObjSubtitle">
                    of actions towards this objective{" "}
                  </span>
                  <AvgCompletion
                    actionCount={actionCount}
                    eo_id={this.props.match.params.id}
                  />
                </span>
              </Col>

              <Col
                lg={4}
                md={6}
                sm={6}
                className="enterprisePieChart col-sm-6 col-md-4"
              >
                <span className="singleStatContainer">
                  <span className="entObjHelpIcon">
                    <span
                      className="ml10"
                      id="actionActivity"
                      onClick={() => this.togglePopup(3)}
                    >
                      <Tooltip />
                    </span>
                    <Popover
                      placement="left"
                      isOpen={this.state.isPopupOpen == 3 ? true : false}
                      target="actionActivity"
                      toggle={() => this.togglePopup(3)}
                    >
                      <PopoverHeader className="popover-header-tooltip">
                        Activity
                      </PopoverHeader>
                      <PopoverBody className="popover-body-tooltip">
                        Timeline of updates made by users to all actions linked
                        with the objective on this page.
                      </PopoverBody>
                    </Popover>
                  </span>
                  <span className="enterpriseObjTitle">Activity</span>
                  <span className="enterpriseObjSubtitle">
                    across actions towards this objective
                  </span>
                  {/* <span className="individualEOpage"> */}
                    <Activity
                      actionCount={actionCount}
                      eo_id={this.props.match.params.id}
                    />
                  {/* </span> */}
                </span>
              </Col>
              </div>
           
            </div>
          ) : null}

          <div className="ml-4 mt-5">
            <ActionsTable
              onPageFilter
              {...this.props}
              allTasks={this.state.tasks}
              getAllData={this.fetchLatestData}
              hideAddActionButtons
              placeholderComp={
                <PlaceholderObjectivesActions
                  status={this.state.status}
                  {...this.props}
                />
              }
              table_params={{
                ...table_column_names["planning"],
                selected: table_column_names["planning"]["1"],
              }}
              isObjectiveDetailsPage={true}
              enterpriseObjectiveId={this.props.match.params.id}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    objectiveActions: state.enterpriseObjective.objectiveActions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchObjectiveActions: (data) =>
      dispatch(actionCreators.getEnterpriseActions(data)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    resetEnterpriseActions: () =>
      dispatch(actionCreators.resetEnterpriseActions()),
    updateNavBar: (data) => dispatch(actionCreators.navBarUpdate(data)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(EnterpriseActions, axios));
